import { useQuery, useMutation, useQueryClient } from '@tanstack/react-query';
import { useStore } from '../context/StoreContext';
import { productsAPI } from '../api';

export const productsKey = (storeId) => ['products', storeId];

export function useProducts() {
  const { selectedStore } = useStore();
  const storeId = selectedStore?.id;
  return useQuery({
    queryKey: productsKey(storeId),
    queryFn: () => productsAPI.list(storeId).then((r) => r.data),
    enabled: !!storeId,
  });
}

export function useCreateProduct() {
  const qc = useQueryClient();
  const { selectedStore } = useStore();
  return useMutation({
    mutationFn: (data) => productsAPI.create(data),
    onSuccess: () => qc.invalidateQueries({ queryKey: productsKey(selectedStore?.id) }),
  });
}

export function useUpdateProduct() {
  const qc = useQueryClient();
  const { selectedStore } = useStore();
  return useMutation({
    mutationFn: ({ id, data }) => productsAPI.update(id, data),
    onSuccess: () => qc.invalidateQueries({ queryKey: productsKey(selectedStore?.id) }),
  });
}

export function useDeleteProduct() {
  const qc = useQueryClient();
  const { selectedStore } = useStore();
  return useMutation({
    mutationFn: (id) => productsAPI.delete(id),
    onSuccess: () => qc.invalidateQueries({ queryKey: productsKey(selectedStore?.id) }),
  });
}
